/**
 * BACKボタンの動作を制御
 * ブラウザ履歴がある場合は戻る、なければフォールバック先へ遷移
 */
document.addEventListener('DOMContentLoaded', () => {
  const backButtons = document.querySelectorAll('[data-action="back"]');

  backButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();

      // 履歴の存在とreferrerをチェック
      if (document.referrer && window.history.length > 1) {
        window.history.back();
      } else {
        // フォールバック先（data-fallback属性で指定可能、デフォルトはtop）
        const fallbackUrl = button.dataset.fallback || '/';
        window.location.href = fallbackUrl;
      }
    });
  });
});
